import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'typeface-spartan';
import './scss/app.scss';
import AppFooter from './ts/components/AppFooter';
import AppHeader from './ts/components/AppHeader';
import AppMain from './ts/components/AppMain';

function App() {
    return (
        <React.Suspense fallback={<div>loading app</div>}>
            <AppHeader />
            <AppMain />
            <AppFooter />
        </React.Suspense>
    );
}

ReactDOM.render(<App />, document.getElementById('app'));
